export default __webpack_public_path__ + "static/media/Rectangle_89.9fbacdc1.png";